import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { I18nProvider } from "../_mcp/i18n/i18nProvider";
import { LayoutProvider, LayoutSplashScreen } from "../_mcp/layout/core";
import { MasterInit } from "../_mcp/layout/MasterInit";
import { AuthInit } from "./modules/auth";
import { ToastProvider } from "./modules/toast/Toast";

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <ToastProvider>
        <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
            </AuthInit>
          </LayoutProvider>
        </I18nProvider>
      </ToastProvider>
    </Suspense>
  );
};

export { App };
